/* global window $ mymuesli */

(function (window, $, mymuesli) {

    /**
     * A view for interactive flavour flowers.
     */
    class FlavourFlowerInteractive extends mymuesli.interface.components.FlavourFlower {

        /**
         * Initialize the event handlers for an interactive flower.
         */
        constructor ($element) {
            super($element);
            this._initializeEventHandlers();
        }

        /**
         * Initialize the onClick-and onDrag-handlers of the flower.
         *
         * @private
         */
        _initializeEventHandlers() {
            const self = this;
            const model = self.getModel();
            $.each(self._leafs, function (type, leafsByType) {
                let dragMode = false;
                let dragModeTimeout = null;

                /*
                 * onClick: set the value
                 * onDbClick: set the value to 0
                 * onMouseDown: start the dragging, the dragging will stop onMouseLeave and after 500ms or onMouseUp
                 * onMouseOver: keep the dragging alive and update the value
                 * onMouseUp: stop the dragging
                 * onTimeout: stop the dragging
                 */
                $.each(leafsByType, function (intensity, leaf) {
                    leaf.click(function () {
                        model[type] = intensity;
                    });
                    leaf.mousedown(function () {
                        dragMode = true;
                        model[type] = intensity;
                    });
                    leaf.mouseup(function () {
                        dragMode = false;
                        model[type] = intensity;
                    });
                    leaf.mouseover(function () {
                        if (!dragMode) return;
                        model[type] = intensity;
                        window.clearTimeout(dragModeTimeout);
                        dragModeTimeout = window.setTimeout(function () {
                            dragMode = false;
                        }, 500);
                    });
                });

                /* No leaf is not click able. So the work-around is a double-click handler on the smallest leaf. */
                self._leafs[type][1].dblclick(function () {
                    self.getModel()[type] = 0;
                });
            });
        }

        /**
         * Calls the generic parser.
         */
        static parse () {
            mymuesli.interface.components.AbstractComponent._parse('.js-flavour-flower-interactive', FlavourFlowerInteractive);
        }

    }

    /* Expose the class and install the components parser. */
    mymuesli.interface.components.FlavourFlowerInteractive = FlavourFlowerInteractive;
    App.load(FlavourFlowerInteractive.parse);

}) (window, $, mymuesli);
